import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import Context from "../../Context";
import Strings from "@my-dld/assets/strings";
import { ProjectProperty } from "@eres/ejari-api/Entity/LeasedProperties";
import { getAllUnitsSearchQuery, getPropertiesRowSearchQuery } from "@eres/ejari-api/api";
import EjariApi from "@eres/ejari-api";
import { showErrorMessage } from "@my-dld/utils/UIUtils";
import PageTitle from "@my-dld/components/PageTitle";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import ListGridDataView from "@my-dld/components/DataView/ListGridDataView";
import UnitsListView from "../components/UnitsListView";
import UnitsGridView from "../components/UnitsGridView";
import { updateUnits } from "../../Utils";
import { showEjariDetails } from "../../NavigationUtils";
import { navigateWithInParent } from "@my-dld/utils/StoreUtils";
import { I8N } from "@eres/core";

interface State {
	isLoading: boolean;
	units: ProjectProperty[];
}

class Units extends Component<RoutedViewProps, State> {
	static contextType = Context;
	context!: React.ContextType<typeof Context>;

	constructor( props: RoutedViewProps ) {
		super( props );
		this.state = {
			isLoading: true,
			units: [],
		};
	}

	private static getTitle( property?: ProjectProperty ) {
		if ( property ) {
			const buildingName = I8N.isRTL() ? property.BuildingNameAr : property.BuildingNameEn;
			return Strings.units_in.replace( "~", buildingName ?? "" );
		}
		return Strings.units;
	}

	componentDidMount() {
		const { property, units } = this.context;
		if ( units ) {
			this.setState( {
				isLoading: false,
				units: units,
			} );
		} else if ( property ) {
			this.loadAllUnits( property );
		}
	}

	render() {
		const { property } = this.context;
		const { isLoading, units } = this.state;
		return <>
			<PageTitle title={ Strings.add_your_property } paths={ [ DashboardBCItem ] }/>
			<ListGridDataView
				isLoading={ isLoading }
				dataAvailable={ units && units.length > 0 }
				title={ Units.getTitle( property ) }
				renderListView={ this.renderListView }
				renderGridView={ this.renderGridView }
				totalCount={ units.length }
				hidePageTitle={ true }>
				{ property?.IsBlocked ?
					<div className="alert alert-user-notification alert-danger fit-content">
						{ Strings.building_blocked_info }
					</div> :
					<div className="text-end mb-3">
						<button
							type="button"
							className="btn btn_1 btn_style1 font-size14"
							onClick={ this.onAddNew }>{ Strings.didnt_find_unit }</button>
					</div> }
			</ListGridDataView>
		</>;
	}

	private loadAllUnits( property: ProjectProperty ) {
		//const query = getAllUnitsSearchQuery( property.BuildingPropertyIdKey ?? property.BuildingPropertyId );
		const query = getPropertiesRowSearchQuery( 0, 0, property.RowValue );
		EjariApi.getBuildingUnits( query ).then( resp => {
			this.setState( {
				isLoading: false,
				units: resp,
			} );
		} ).catch( e => {
			this.setState( { isLoading: false } );
			showErrorMessage( e );
		} );
	}

	private renderListView = () => {
		const { units } = this.state;
		return <UnitsListView
			properties={ units ? units : [] }
			onPropertySelect={ this.onPropertySelect }/>;
	};

	private renderGridView = () => {
		const { units } = this.state;
		return <UnitsGridView
			properties={ units ? units : [] }
			onPropertySelect={ this.onPropertySelect }/>;
	};

	private onPropertySelect = ( property: ProjectProperty ) => {
		updateUnits( this.state.units );
		showEjariDetails( property );
	};

	private onAddNew = () => {
		updateUnits( this.state.units );
		navigateWithInParent( "addproperty", "new" );
	};
}

export default Units;
